import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

const TestList = () => {
    const [tests, setTests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { encryptedApiCall, API_BASE_URL, logout } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const categoryId = searchParams.get('categoryId');

    useEffect(() => {
        fetchTests();
    }, [categoryId]);

    const fetchTests = async () => {
        try {
            setLoading(true);
            const url = categoryId 
                ? `${API_BASE_URL}/tests?categoryId=${categoryId}`
                : `${API_BASE_URL}/tests`;
            
            const data = await encryptedApiCall(url, {
                method: 'GET'
            });
            setTests(data);
        } catch (err) {
            if (err.message && err.message.includes('401')) {
                logout();
                navigate('/login');
                return;
            }
            setError(err.message || 'Failed to fetch tests');
        } finally {
            setLoading(false);
        }
    };

    const handleTestClick = (testId) => {
        navigate(`/test/${testId}`);
    };

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <Button variant="outline-secondary" onClick={() => navigate('/categories')} className="me-2">
                        ← Back to Categories
                    </Button>
                    <h2 className="d-inline ms-3">Tests</h2>
                </div>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            {tests.length === 0 ? (
                <Alert variant="info">
                    No tests available{categoryId ? ' for this category' : ''}. 
                    {categoryId && ' You may not have permission to access tests in this category.'}
                </Alert>
            ) : (
                <div className="row">
                    {tests.map((test) => (
                        <div key={test.id} className="col-md-6 mb-3">
                            <Card style={{ height: '100%' }}>
                                <Card.Body>
                                    <Card.Title>{test.name}</Card.Title>
                                    <Card.Text className="text-muted">
                                        <strong>Category:</strong> {test.category_name || 'N/A'}<br />
                                        {test.description && (
                                            <>
                                                <strong>Description:</strong> {test.description}
                                            </>
                                        )}
                                    </Card.Text>
                                    <Button 
                                        variant="primary" 
                                        onClick={() => handleTestClick(test.id)}
                                    >
                                        Start Practice
                                    </Button>
                                </Card.Body>
                            </Card>
                        </div>
                    ))}
                </div>
            )}
        </Container>
    );
};

export default TestList;

